module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lobby-index"
  }, [_c('div', {
    staticClass: "container pb20"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('IndexLeader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('IndexVideo', {
    attrs: {
      "type": "COURSE"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('IndexVideo', {
    attrs: {
      "type": "LECTURE"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt10"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('IndexCourseCenter')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('IndexGarden')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-049ed134"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/index/SceneryIndex.vue
// module id = 946
// module chunks = 1